import React, {useState} from 'react';
import styles from './admin-registration-details.module.scss';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  REGISTRATION_BP_ASSIGNED,
  REGISTRATION_BP_ASSIGNED_ERROR,
  REGISTRATION_BP_ASSIGNED_SUCCESS
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import editIcon from "../../../../../../assets/edit.svg";
import {CurrencyInput, DateInput, TextInput} from "../../../../../../components/form/form";
import {useValidation} from "../../../../../../hooks/use-validation";
import checkIcon from "../../../../../../assets/orders-table-accept.svg";
import rejectIcon from "../../../../../../assets/orders-table-reject.svg";
import SecondaryMarketService from "../../../../../../services/secondary-market-service";
import {numeric, required} from "../../../../../../helpr/generic-validation-rules";
import RejectRegistrationModalContent from "../reject-registration/reject-registration";
import {getDeliveryModes, getInvestorCategory, getSettBankList} from "../../../../../../helpr/orderFormData";
import {getTaxStatusTypes} from "../../../../../../helpr/transferFormData";
import {getOrganizationType} from "../../../../../../helpr/registrationFormData";

const AdminRegistrationDetailsModalContent = ({context, onClose}) => {
  const SUCCESS_TITLE = "INVESTOR REGISTRATION COMPLETED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const [ loading, setLoading ] = useState(false);
  const [ page, setPage ] = useState(0);

  const secondaryMarketService = new SecondaryMarketService();
  const { selectedRegistration, setRegistrationList } = context;
  const [ registration, setRegistration ] = useState(selectedRegistration.current);
  const [ toggleEditFields, setToggleEditFields ] = useState({
    securityId: false,
    settlementDate: false,
    faceAmount: false
  });

  //Setup validator and transfer instruction state
  const confirmRegistrationState = useValidation(
    confirmRegistrationModalValidator,
    confirmRegistrationModalObj(selectedRegistration.current),
    {border: '1px solid red'});
  const { validate, getTextFieldProps } = confirmRegistrationState;

  const complete = async () => {
    setLoading(true)
    try {
      const { formState, isFormValid } = validate();
      console.log(formState, isFormValid);
      if(isFormValid){
        await secondaryMarketService.completeRegistration(registration.registrationId, formState);
        setRegistrationList(prev => {
          const updatedList = prev.map(p => {
            if(p.registrationId === registration.registrationId){
              return {
                ...p,
                ...registration,
                bpId: formState.bpId,
                registrationStatus: REGISTRATION_BP_ASSIGNED
              }
            }
            return p
          });
          return updatedList;
        });
        setPage(1)
      }
    }catch(error){
      setPage(2)
    }finally{
      setLoading(false);
    }
  }

  const onConfirmEdit = key => {
    const { formState, isFormValid } = validate();
    console.log(formState, isFormValid);
    if(isFormValid){
      setToggleEditFields({
        ...toggleEditFields,
        [key]: !toggleEditFields[key]
      });
      setRegistration({
        ...registration,
        [key]: formState[key]
      });
    }
  }

  const toggleEditableFields = key => {
    setToggleEditFields({
      ...toggleEditFields,
      [key]: !toggleEditFields[key]
    });
  }

  const renderEditableFields = (key, input) => {
    return toggleEditFields[key] ? (
      <div className={styles['edit-field']}>
        {input}
        <div onClick={() => onConfirmEdit(key)} className={styles['confirm-scale-down']}>
          <img alt="Confirm" src={checkIcon} />
        </div>
        <div onClick={() => toggleEditableFields(key)} className={styles['cancel-scale-down']}>
          <img alt="Cancel" src={rejectIcon}/>
        </div>
      </div>
    ) : (
      <div>
        {registration[key]}
        {registration.registrationStatus === '2'
          ? <img className={styles['edit']} onClick={()=>toggleEditableFields(key)} alt="Edit" src={editIcon} /> : ''}
      </div>
    )
  }

  const renderConfirmResult = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={REGISTRATION_BP_ASSIGNED_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={REGISTRATION_BP_ASSIGNED_ERROR} onClose={onClose}/>
      case 3:
        return <RejectRegistrationModalContent context={context} onBack={() => setPage(0)} onClose={onClose} />
      default:
    }
  }

  const renderInvestorCategoryData = () => {
    return registration.investorCategory.type === 'INDV' ? (
      <>
        <Row>
          <Col lg={6} className={styles['label']}>Nationality</Col>
          <Col lg={6} className={styles['value']}>{registration.nationality}</Col>
        </Row>
        <Row>
          <Col lg={6} className={styles['label']}>US Resident or US Person</Col>
          <Col lg={6} className={styles['value']}>{registration.usResident}</Col>
        </Row>
        <Row>
          <Col lg={6} className={styles['label']}>US Citizen</Col>
          <Col lg={6} className={styles['value']}>{registration.usCitizen}</Col>
        </Row>
        <Row>
          <Col lg={6} className={styles['label']}>US Permanent Resident Card</Col>
          <Col lg={6} className={styles['value']}>{registration.usResidentCard}</Col>
        </Row>
      </>
    ) : (
      <>
        <Row>
          <Col lg={6} className={styles['label']}>Type of Organization</Col>
          <Col lg={6} className={styles['value']}>{renderOrgTypeValue(registration.organizationType)}</Col>
        </Row>
        <Row>
          <Col lg={6} className={styles['label']}>Name of Parent Organization, if any</Col>
          <Col lg={6} className={styles['value']}>{registration.parentCompany === '' ? '-' : registration.parentCompany}</Col>
        </Row>
      </>
    )
  }

  const renderBpIdField = () => {
    return registration.registrationStatus === '2' ? (
      <div className={styles['edit-field']}>
        <TextInput inputProps={getTextFieldProps('bpId')} placeholder={""} />
      </div>
    ) : <>{registration.bpId === '' ? '-': registration.bpId}</>
  }

  const renderCategoryValue = key => getInvestorCategory().filter(t => t.value === key)[0]?.name;
  const renderDeliveryValue = key => getDeliveryModes().filter(t => t.value === key)[0]?.name;
  const renderTaxStatusValue = key => getTaxStatusTypes().filter(t => t.value === key)[0]?.name;
  const renderBankValue = key => getSettBankList().filter(t => t.value === key)[0]?.name;
  const renderOrgTypeValue = key => getOrganizationType().filter(t => t.value === key)[0]?.name;

  return page === 0 ? (
    <div className={styles['admin-registration-details-modal-content']}>
      <Row>
        <Col lg={12}>
          <div>
            <Row>
              <Col lg={6} className={styles['label']}>BP ID</Col>
              <Col lg={6} className={styles['value']}>
                {renderBpIdField()}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Security ID/ISIN No.</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields('securityId',
                  <TextInput inputProps={getTextFieldProps('securityId')} placeholder={""} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Settlement Date</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'settlementDate',
                  <DateInput inputProps={getTextFieldProps('settlementDate')}/>)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Face Amount</Col>
              <Col lg={6} className={styles['value']}>
                {renderEditableFields(
                  'faceAmount',
                  <CurrencyInput inputProps={getTextFieldProps('faceAmount')} placeholder={""} />)}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Type of Investor</Col>
              <Col lg={6} className={styles['value']}>
                { renderCategoryValue(registration.investorCategory.type) }{' '}
                { registration.investorCategory.type === 'CORP' ? ` (${registration.investorCategory.under})` : ''}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Investor Name/Business Name</Col>
              <Col lg={6} className={styles['value']}>{registration.investor}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Date of Birth/Incorporation</Col>
              <Col lg={6} className={styles['value']}>{registration.dateBirthIncorporation}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Place of Birth/Incorporation</Col>
              <Col lg={6} className={styles['value']}>{registration.placeBirthIncorporation}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Country of Domicile</Col>
              <Col lg={6} className={styles['value']}>{registration.domicile}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            { renderInvestorCategoryData() }
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Telephone Number</Col>
              <Col lg={6} className={styles['value']}>{registration.telNo}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Email Address</Col>
              <Col lg={6} className={styles['value']}>{registration.emailAddress}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Present Address</Col>
              <Col lg={6} className={styles['value']}>
                {`${registration.presentAddress.streetAddress} ${registration.presentAddress.districtOrTown} 
                ${registration.presentAddress.city} ${registration.presentAddress.stateProvinceRegion}
                ${registration.presentAddress.country} ${registration.presentAddress.zipCode}`}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Permanent Address</Col>
              <Col lg={6} className={styles['value']}>
                {`${registration.permanentAddress.streetAddress} ${registration.permanentAddress.districtOrTown}
                ${registration.permanentAddress.city} ${registration.permanentAddress.stateProvinceRegion}
                ${registration.permanentAddress.country} ${registration.permanentAddress.zipCode}`}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Mailing Address</Col>
              <Col lg={6} className={styles['value']}>
                {`${registration.mailingAddress.streetAddress} ${registration.mailingAddress.districtOrTown} 
                ${registration.mailingAddress.city} ${registration.mailingAddress.stateProvinceRegion}
                ${registration.mailingAddress.country} ${registration.mailingAddress.zipCode}`}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Delivery Mode</Col>
              <Col lg={6} className={styles['value']}>
                {renderDeliveryValue(registration.statementDeliveryMode)}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Primary Contact Name</Col>
              <Col lg={6} className={styles['value']}>
                {`${registration.primaryContact.salutation} ${registration.primaryContact.firstName}
                ${registration.primaryContact.middleName} ${registration.primaryContact.lastName}`}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Primary Contact Telephone Number</Col>
              <Col lg={6} className={styles['value']}>
                {registration.primaryContactTelNo}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Primary Contact Email Address</Col>
              <Col lg={6} className={styles['value']}>
                {registration.primaryContactEmailAddress}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Occupation/Nature of Business</Col>
              <Col lg={6} className={styles['value']}>
                {registration.nature}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Souce of Income</Col>
              <Col lg={6} className={styles['value']}>
                {registration.incomeSource ? registration.incomeSource.join(', ') : '-'}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>TIN</Col>
              <Col lg={6} className={styles['value']}>
                {registration.tin}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Tax Status</Col>
              <Col lg={6} className={styles['value']}>
                {renderTaxStatusValue(registration.taxStatus)}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Current/Savings Account Number</Col>
              <Col lg={6} className={styles['value']}>
                {registration.accountNumber}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Bank Name</Col>
              <Col lg={6} className={styles['value']}>
                {renderBankValue(registration.bankName)}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Bank Branch</Col>
              <Col lg={6} className={styles['value']}>
                {registration.bankBranch}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {registration.registrationStatus === '2'  ? (
        <>
          <Row className={styles['button-row']}>
            <Col xs={12} lg={4}>
              <div className={styles['close-button']}>
                <Button variant="secondary" onClick={() => onClose()}>
                  CLOSE
                </Button>
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className={styles['reject-button']}>
                <Button variant="danger" onClick={() => setPage(3)}>
                  REJECT
                </Button>
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className={styles['complete-button']}>
                <Button disabled={loading} onClick={() => complete()}>
                  {loading ? <Spinner size="sm" animation="border"/> : 'UPDATE BROKER'}
                </Button>
              </div>
            </Col>
          </Row>
        </>
      ) : ''}
    </div>
  ) : renderConfirmResult();
}

const confirmRegistrationModalObj = obj => {
  return {
    fields: {
      bpId: {
        value: obj.bpId,
        style: {}
      },
      securityId: {
        value: obj.securityId,
        style: {}
      },
      faceAmount: {
        value: obj.faceAmount.toString(),
        style: {}
      },
      settlementDate: {
        value: obj.settlementDate,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

const confirmRegistrationModalValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    bpId: [required],
    securityId: [required],
    faceAmount: [required, numeric],
    settlementDate: [required]
  },
  dynamicFields: {}
}

export default AdminRegistrationDetailsModalContent;
